import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

const BORDER_COLOR = "#1d1d1d1a";
const MENU_ITEMS_WIDTH = "300px";

export const SubmenuWrapper = styled.div`
  cursor: default;
  position: absolute;
  top: 42px;
  right: 0;
  height: fit-content;

  ${({ $withFeaturedPost }) =>
    $withFeaturedPost
      ? css`
          width: 753px;
        `
      : css`
          width: ${MENU_ITEMS_WIDTH};
        `}

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;

  background: #ffffff;
  box-shadow: 0px 8px 16px 0px #00000014;
  border: 1px solid ${BORDER_COLOR};
  border-radius: 32px;

  @media ${({ theme }) => theme.media.mobileForHeader} {
    position: static;
    width: 100%;
    box-shadow: none;
    border: none;
    border-radius: 0;
    padding: 0;
    gap: 0;
  }
`;

export const SubmenuTabList = styled.div`
  padding: 4px 0 28px;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: ${MENU_ITEMS_WIDTH};

  @media ${({ theme }) => theme.media.mobileForHeader} {
    width: 100%;
  }
`;

export const SubmenuTabItem = styled.div`
  padding: 4px 8px;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  @media ${({ theme }) => theme.media.mobileForHeader} {
  }
`;

export const SubmenuTabLink = styled(Link)`
  padding: 12px;
  margin: 0;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border-radius: 24px;
  text-decoration: none;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(29, 29, 29, 0.04);
  }

  @media ${({ theme }) => theme.media.mobileForHeader} {
  }
`;

export const SubmenuTabIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const SubmenuLinkContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  justify-content: flex-start;
  width: calc(100% - 32px);
`;

export const SubmenuTabTitle = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.85);
`;

export const SubmenuTabDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.5);
  white-space: normal;
  text-align: left;
`;

export const FeaturedBlogPostContainer = styled.div`
  padding: 16px;
  width: calc(100% - 20px - ${MENU_ITEMS_WIDTH});
  flex-grow: 1;
  align-self: stretch;
  min-height: 514px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: -20px;
    top: 16px;
    bottom: 16px;
    width: 1px;
    height: calc(100% - 16px * 2);
    box-shadow: 1px 0 ${BORDER_COLOR};
  }
`;
